<template>
    <div class="container-pieChart_v_m">
        <v-chart :options="option"  autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'

import 'echarts/lib/chart/scatter';

import 'echarts/lib/component/polar';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'
import 'zrender/lib/svg/svg'


export default {
  name: 'pieChart_v_m',
  props: {  
    title:{
      type: String,
      default: ""
    },
    num:{
       type: Number,
       default: 100
    }
  },
  data () {  
    return {     
       option:{}
    }
  },
  methods: {
 
  },
  mounted () {
    this.option = {
       legend: {
      
        x: '5%',
        y: 'bottom',
         itemWidth: 6,
         itemHeight: 6,
        icon: 'rect',
        align:"left",
        textStyle: {
            color: "#fff", // 图例文字颜色
          fontSize:9
        },
        itemGap: 0,
        data: ["广州番禺万科里", '广州天河城百货', '广州北京路225', '广州番禺万科里','广州云门店']
    },
       grid: {
        left: '5%',
        right: '5%',
        bottom: '15%',
        top: "10%",
        containLabel: true
    },
        xAxis: {
             splitLine:{ 
                 lineStyle:{
                     color: ['#292C38']
                 }
              },
            axisLine: {
              lineStyle: {
                  color: "#C0C8FF",
                  width: 1
              }
            },
            axisLabel: {
              textStyle: {
                  color: "#fff"               
              }
            },
             axisTick:{show:false},
        },
        yAxis: {
           axisLabel: {
            textStyle: {
                color: "#fff"               
            }
         },
           axisTick:{show:false},
            splitLine:{ 
                 lineStyle:{
                     color: ['#292C38']
                 }
            },
             axisLine: {
              lineStyle: {
                  color: "#fff",
                  width: 1
              }
            }
        },
    
        series: [
          {
            name: '广州番禺万科里',
            type: 'scatter',
            data: [
                [67, 45],
                [30, 24]
            ]
        },
        {
            name: '广州天河城百货',
            type: 'scatter',
            data: [
                [-67, 45],
                [30, -24]
            ]
        },
        {
            name: '广州北京路225',
            type: 'scatter',
            data: [
                [-47, -45],
                [20, -14],
                [50, 20]
            ]
        },
        {
            name: '广州番禺万科里',
            type: 'scatter',
            data: [
                [-17, -25],
                [-20, 44],
                [30, 70]
            ]
        },
        {
            name: '广州云门店',
            type: 'scatter',
            data: [
                [-17, -45],
                [-50, 74],
                [20, 70]
            ]
        }
        ]
    };

  },
  components: {
      'v-chart': ECharts
  }  
}
</script>

<style lang="scss">

        .container-pieChart_v_m{
           height: 100%;
            width: 100%;
        .echarts{
            width: 100%;
            height: 100%;
        }
    }
</style>